import type { PaymentStatus } from './appointment.model';

export enum GiftCardStatus {
  Cart = 'Cart',
  PendingPayment = 'PendingPayment',
  Active = 'Active',
  Used = 'Used',
  Expired = 'Expired',
}

export interface GiftCard {
  id?: number;
  uuid: string;
  locationId: number;
  code: string | null;
  value: number;
  expiresAt?: Date | string | null;
  status: GiftCardStatus;
  recipientName?: string;
  recipientEmail?: string;
  senderName?: string;
  senderEmail?: string;
  senderMessage?: string;
  /** 'in-salon' when sold by staff - the client pays it from a link/QR. */
  utmSource?: string;
  lastPaymentStatus?: PaymentStatus | null;
}
